<template>
  <div class="history">
    <swiper
      id="history"
      class="swiper"
      :options="HistoryswiperOption"
      v-if="history.length > 0"
    >
      <swiper-slide
        class="one"
        v-if="index == 0"
        v-for="(item, index) in history"
        :key="index"
      >
        <div
          class="background trans"
          :style="{ background: 'url(' + item.image + ')' }"
        ></div>
        <div class="content trans" style="opacity: 1">
          <span class="brief fz24 block SOURCEHANSANSCN-MEDIUM" :title="item.info">{{
            item.info
          }}</span>
          <span class="time fz70 block DEMOS-LT-MEDIUM-ITALIC">{{ item.year }}年</span>
          <span class="text inline-block trans"></span>
        </div>
        <i class="line inline-block" style="width: 6466px"></i>
      </swiper-slide>
      <swiper-slide
        class="two"
        v-if="index != 0"
        v-for="(item, index) in history"
        :key="index"
      >
        <div class="slide" :class="{ active_oli_slide: index % 2 != 0 }">
          <div class="brief trans fz16 SOURCEHANSANSCN-MEDIUM" :title="item.info">
            {{ item.info }}
          </div>
          <div class="title trans fz50 DEMOS-LT-MEDIUM-ITALIC">{{ item.year }}年</div>
          <div class="circle trans inline-block"><i></i></div>
        </div>
        <div class="slide to" :class="{ active_oli_slide: index % 2 == 0 }">
          <div class="title trans fz50 DEMOS-LT-MEDIUM-ITALIC">{{ item.year }}年</div>
          <div class="brief trans fz16 SOURCEHANSANSCN-MEDIUM">{{ item.info }}</div>
          <div class="circle trans inline-block"><i></i></div>
        </div>
      </swiper-slide>

      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
      <!--      <div class="swiper-pagination" slot="pagination"></div>-->
    </swiper>
    <div class="swiper_ip">
      <div class="box_swipe" :style="{ background: 'url(' + history[0].image + ')' }">
        <div class="content" style="opacity: 1">
          <span class="time block">{{ history[0].year }}年</span>
          <span class="brief block">{{ history[0].info }}</span>
          <span class="text"></span>
        </div>
      </div>
      <div class="wap_ces">
        <div class="befi_ty" v-for="(item, index) in history">
          <template v-if="index != 0">
            <div class="slide" :class="{ active_oli_slide: index % 2 == 0 }">
              <div class="box_img_info">
                <div class="time">{{ item.year }}年</div>
                <div class="info">{{ item.info }}</div>
              </div>
              <div class="circle trans inline-block"><i></i></div>
            </div>
          </template>

          <div class="slide slide_top" :class="{ active_oli_slide: index % 2 != 0 }">
            <div class="box_img_info">
              <div class="time">{{ item.year }}年</div>
              <div class="info">{{ item.info }}</div>
              <!-- <div class="time">{{ item.year }}年</div> -->
            </div>
            <div class="circle trans inline-block"><i></i></div>
          </div>
        </div>
      </div>
      <div class="line"></div>
    </div>
  </div>
</template>

<script>
import { getCourseInfo } from "../../api/apis";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  name: "EnterpriseHistory",
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      history: [],
      HistoryswiperOption: {
        slidesPerView: 4,
        spaceBetween: 53,
        // loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  created() {
    this.GetNewsInfo();
  },
  methods: {
    GetNewsInfo() {
      getCourseInfo().then((res) => {
        this.history = res.data;
      });
    },
  },
};
</script>

<style scoped lang="less">
.history {
  width: 100%;
  height: 690px;
  margin-bottom: 100px;
}

#history {
  border-top: 1px solid #e5e5e5;
  background-size: cover !important;
  position: relative;
  border-bottom: 1px solid #e5e5e5;
  height: 100%;

  .swiper-wrapper .one {
    width: 50% !important;
    height: 619px;
    text-align: right;
    position: relative;
    z-index: 2;
    padding-top: 71px;

    .background {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 1;
      margin: auto;
      //background-position: center center !important;
      background-repeat: no-repeat !important;
      background-size: 100% 100% !important;
    }

    .content {
      width: 55%;
      position: relative;
      z-index: 5;
      text-align: left;
      margin-left: 38%;
      margin-top: 96px;
      padding-top: 106px;

      .block {
        display: block;
      }

      .inline-block {
        display: inline-block;
      }

      .brief {
        font-size: 22px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #ffffff;
        margin-bottom: 14px;
        position: absolute;
        bottom: 106px;
      }

      .time {
        font-size: 40px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #ffffff;
      }

      .text {
        width: 38px;
        height: 38px;
        border: 2px solid #ffffff;
        border-radius: 50%;
        position: relative;
        margin-top: 14px;
      }

      .text::before {
        width: 20px;
        height: 20px;
        background: #ffffff;
        border-radius: 50%;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 2;
        margin: auto;
        content: "";
        transition: all 0.8s ease 0s;
      }
    }

    .line {
      display: inline-block;
      height: 0;
      border-top: 1px solid #c2c2c2;
      position: absolute;
      left: 42%;
      right: 50%;
      top: 363px;
      bottom: auto;
      z-index: 3;
      margin-right: 17px;
      transition: all 6000ms ease 0s;
    }
  }

  .swiper-wrapper .two {
    width: 290px !important;
    position: relative;
    z-index: 3;
    margin-top: 30px;
    //padding-top: 60px;
    margin-right: 10px !important;

    .slide {
      min-height: 266px;
      width: 100%;
      position: relative;
      //margin-left: 60px;
      opacity: 0;

      .brief {
        width: 100%;
        // height: 160px;
        min-height: 53px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 6;
        overflow: hidden;
        margin: 16px 0 6px;
        position: absolute;
        bottom: 52px;
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 500;
        line-height: 33px;
        color: #666666;
      }

      .title {
        width: 100%;
        color: #0092dd;
        font-size: 40px;
        line-height: 60px;
        position: absolute;
        bottom: -11px;
      }

      .circle {
        width: 20px;
        height: 20px;
        border: 2px solid #0092dd;
        border-radius: 50%;
        position: absolute;
        left: 0;
        bottom: -79px;
        z-index: 1;

        i {
          width: 14px;
          height: 14px;
          display: block;
          background: #0092dd;
          border-radius: 50%;
          position: relative;
          margin: 3px auto;
        }

        i::before {
          height: 30px;
          display: block;
          border-right: 1px solid #0092dd;
          position: absolute;
          bottom: 18px;
          right: 50%;
          z-index: 2;
          content: "";
          animation: line 1s linear;
          -webkit-animation: line 1s linear;
        }
      }
    }

    .active_oli_slide {
      opacity: 1;
    }

    .to {
      margin-left: 0;
      margin-top: 91px;

      .title {
        padding-left: 0;
        top: 22px;
      }

      .brief {
        margin: 0px 0 16px;
        top: 90px;
        padding-left: 0;
        bottom: 60px;
      }

      .circle {
        left: 0;
        right: 140px;
        top: -37px;
        bottom: auto;

        i::before {
          width: 90px;
          bottom: auto;
          top: 18px;
        }
      }
    }
  }
}

.swiper_ip {
  display: none;
}

@media (max-width: 1200px) {
  .history {
    width: auto;
    height: auto;
    margin-bottom: 0;
    overflow: hidden;

    #history {
      display: none;
    }

    .swiper_ip {
      display: block;
      position: relative;

      .line {
        height: 6664px;
        width: 0px;
        border: 1px solid #d9d9d9;
        position: absolute;
        left: 50%;
        top: 117px;
      }

      .box_swipe {
        height: 275px;
        background-size: 100% !important;
        padding-top: 0.1px;

        .content {
          width: 40%;
          position: relative;
          z-index: 2;
          text-align: left;
          margin-left: 56%;
          margin-top: 90px;

          .block {
            display: block;
          }

          .inline-block {
            display: inline-block;
          }

          .brief {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #ffffff;
            margin-bottom: 7px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            //-webkit-line-clamp: 2;
            overflow: hidden;
          }

          .time {
            font-size: 23px;
            font-family: PingFang SC;
            font-weight: 800;
            color: #ffffff;
          }

          .text {
            width: 21px;
            height: 21px;
            border: 2px solid #ffffff;
            border-radius: 50%;
            position: absolute;
            left: -35px;
            top: 0px;
          }

          .text::before {
            width: 10px;
            height: 10px;
            background: #ffffff;
            border-radius: 50%;
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            z-index: 2;
            margin: auto;
            content: "";
            transition: all 0.8s ease 0s;
          }
        }
      }

      .wap_ces {
        width: auto;
        padding: 0 15px;
        margin-top: 37px;
        margin-bottom: 50px;

        .befi_ty:first-child {
          display: none;
        }

        .befi_ty {
          display: flex;

          .slide {
            position: relative;
            min-height: 105px;
            width: 50%;
            opacity: 0;

            .circle {
              width: 12px;
              height: 12px;
              border: 2px solid #0092dd;
              border-radius: 50%;
              position: absolute;
              right: -8px;
              top: 0;
              z-index: 1;

              i {
                width: 6px;
                height: 6px;
                display: block;
                background: #0092dd;
                border-radius: 50%;
                position: relative;
                margin: 3px auto;
                transform: rotate(-90deg);
              }

              i::before {
                height: 24px;
                display: block;
                border-right: 1px solid #0092dd;
                position: absolute;
                bottom: 11px;
                right: 50%;
                z-index: 2;
                content: "";
                animation: line 1s linear;
                -webkit-animation: line 1s linear;
              }
            }

            .box_img_info {
              width: 135px;
              position: absolute;
              text-align: right;
              right: 45px;

              .time {
                font-size: 13px;
                font-family: PingFang SC;
                font-weight: 800;
                color: #0092dd;
                line-height: 21px;
              }

              .info {
                font-size: 12px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #666666;
                line-height: 17px;
              }
            }
          }

          .slide_top {
            .circle {
              left: -6px;
              top: 0;

              i {
                transform: rotate(90deg);
              }
            }

            .box_img_info {
              position: absolute;
              right: 0;
              left: 45px;
              text-align: left;
            }
          }

          .active_oli_slide {
            opacity: 1;
          }
        }
      }
    }
  }
}
</style>
<style lang="less">
.history {
  #history {
    .swiper-button-prev,
    .swiper-button-next {
      width: 48px;
      height: 48px;
      outline: none;
      border: none;
      top: 331px;
    }

    .swiper-button-prev {
      background-image: url("../../assets/AboutImg/left.png");
      background-size: 100% 100%;
      left: 71px;
    }

    .swiper-button-next {
      background-image: url("../../assets/AboutImg/right.png");
      background-size: 100% 100%;
      right: 99px;
    }
  }
}
</style>
